import React, { useState } from "react"
import GenericDropdown from "../../../common/components/genericDropdown"
import SpecialAdCategories from "../../../common/consts/specialAdCategory"

const SpecialAdCategoryDropdown = (props) => {
  const { campaignDetailsState, handleChange } = props

  const [menuOpen, setMenuOpen] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)

  const selectedIndex = SpecialAdCategories.options.findIndex(
    (option) => option.value === campaignDetailsState.selectedCategory
  )

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget)
    setMenuOpen(true)
  }

  const handleMenuClose = () => {
    setMenuOpen(false)
  }

  const handleMenuClick = (index) => {
    const selectedCategory = SpecialAdCategories.options[index].value
    handleChange("selectedCategory", null, selectedCategory)
    handleMenuClose()
  }

  return (
    <div className="text-field">
      <div className="creation-generic-dropdown-label">Special Ad Category</div>
      <GenericDropdown
        header={selectedIndex >= 0 ? SpecialAdCategories.options[selectedIndex].name : "Choose Special Ad Category"}
        selectOptionCallback={handleMenuClick}
        options={SpecialAdCategories.options}
        open={menuOpen}
        anchorEl={menuAnchorEl}
        selectedIndexes={selectedIndex >= 0 ? [selectedIndex] : []}
        openDropdownCallback={handleMenuOpen}
        allowAutoSuggest={false}
        closeDropdownCallback={handleMenuClose}
        allowNoSelection={true}
        buttonClassName="creation-generic-dropdown-button"
        menuClassName="creation-generic-dropdown-menu"
      />
    </div>
  )
}

export default SpecialAdCategoryDropdown
